module.exports = __webpack_public_path__ + "img/sooth.cb6a769d.svg";